// tslint:disable:ban

import * as ReactDOM from 'react-dom';
import * as ReactDOMClient from 'react-dom/client';

const rootsMap = new WeakMap<Element, ReactDOMClient.Root>();

// used to render datepicker, tooltips, etc... stuff that can be clipped by 'overflow: hidden' in parent
const BODY_PORTAL = ({ children }) => ReactDOM.createPortal(children, document.body);

function safeRender(reactEl: any, node: Element, callback?: () => void) {
    try {
        if (!(node instanceof Element)) {
            console.warn('React safeRender() skipped invalid node', node, 'for elem:', reactEl);
            return;
        }

        let root = rootsMap.get(node);
        if (!root) {
            root = ReactDOMClient.createRoot(node);
            rootsMap.set(node, root);
        }

        root.render(reactEl);
        if (callback) {
            callback();
        }
        return root;
    } catch (e) {
        console.warn('React createRoot() exception\nnode', node, '\nelem:', reactEl, '\nexception', e);
    }
}

function safeUnmountComponentAtNode(node: HTMLElement, silent = false) {
    try {
        const root = rootsMap.get(node);
        if (root) {
            root.unmount();
            rootsMap.delete(node);
            return;
        }

        // old method fallback
        ReactDOM.unmountComponentAtNode(node);
    } catch (e) {
        if (!silent) {
            console.warn('React unmountComponentAtNode() exception for node', node, e);
        }
    }
}

const renderToString = (() => {
    const cache = {};
    return (Component: JSX.Element, cacheKey: string, callback: (html: string) => void) => {
        if (cacheKey && cache[cacheKey]) {
            callback(cache[cacheKey]);
            return;
        }

        const div = document.createElement('div');
        const root = ReactDOMClient.createRoot(div);
        root.render(Component);

        setTimeout(() => {
            if (cacheKey) {
                cache[cacheKey] = div.innerHTML;
                callback(cache[cacheKey]);
            } else {
                callback(div.innerHTML);
            }
            root.unmount();
        }, 0);
    };
})();

export const ReactUtils = {
    BODY_PORTAL,
    safeRender,
    safeUnmountComponentAtNode,
    renderToString,
};
